import { useContext } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import { TicketPrioritiesContext as TicketPrioritiesContext } from '../TicketPrioritiesContext';
import SearchIcon from '@material-ui/icons/Search';
import { FilterContainer } from 'components';

let Filters = () => {
    let { search, updateSearch, doSearch } = useContext(TicketPrioritiesContext);

    return (
        <FilterContainer onSubmit={() => doSearch(search)}>
            <Grid item>
                <TextField
                    name="search"
                    label="Description"
                    value={search.description}
                    onChange={(e) => updateSearch({
                        ...search,
                        description: e.target.value
                    })}
                />
            </Grid>

            <Grid item>
                <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filters;